import { useMemo } from 'react';

import styles from './styles.module.css';
import WsConnected from '@/assets/icons/ws-connected.svg?react';
import WsDisconnected from '@/assets/icons/ws-disconnected.svg?react';
import { useWebSocket } from '@/context/WebSocketContext';
import {
  getDateWithTimeZone,
  setFormatDateToView
} from '@/solaris-lens-common-lib/src/utils/dates';

interface WebSocketIndicatorProps {
  turbineStatus?: {
    powerStatus?: string;
    updatedAt?: string;
  };
}

const WebSocketIndicator = ({ turbineStatus }: WebSocketIndicatorProps = {} as WebSocketIndicatorProps) => {
  const { lastUpdateTime, readyState } = useWebSocket();

  const displayTime = useMemo(() => {
    if (turbineStatus?.powerStatus === 'offline' && turbineStatus?.updatedAt) {
      return setFormatDateToView(
        getDateWithTimeZone({
          date: new Date(turbineStatus.updatedAt),
          timezone: Intl.DateTimeFormat().resolvedOptions().timeZone
        })
      );
    }
    return lastUpdateTime;
  }, [turbineStatus, lastUpdateTime]);

  const wsIcon =
    readyState === 1 ? (
      <WsConnected className={styles.wsConnectedIconWithStroke} />
    ) : (
      <WsDisconnected className={styles.wsDisconnectedIconWithStroke} />
    );

  return (
    <div className={styles.WSContainer}>
      <p className={styles.lastUpdateText}>Last Update</p>
      <p className={styles.lastUpdateValue}>{displayTime}</p>
      <span className={styles.wsIcon}>{wsIcon}</span>
    </div>
  );
};

export default WebSocketIndicator;
